




import { Component, Vue, Prop } from "vue-property-decorator";
const images = require.context("../assets/game-icons/", false, /\.png$/);

@Component
export default class AuthorIcon extends Vue {
  @Prop() private game!: string;

  getGameIcon(): string {
    try {
      return images("./" + this.game.toLowerCase() + ".png");
    } catch (e) {
      return images("./not-found-game.png");
    }
  }
  geGameAlt(): string {
    return this.game + " icon ";
  }
}
